export default __webpack_public_path__ + "static/media/visual_2.b07c096d.png";